import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { formatDOB } from "../../CommonJquery/CommonJquery";
import {
  Edit3,
  Clock,
  User,
  MapPin,
  Calendar as CalendarIcon,
} from "lucide-react";

export default function SearchListData({
  showModal,
  handleClose,
  searchText,
  setSearchText,
  filteredTopicList = [],
  handleEditKundali,

}) {
  const location = useLocation();

  return (
    <Modal
      size="lg"
      show={showModal}
      onHide={handleClose}
      centered
      contentClassName="bg-slate-900 text-white rounded-xl"
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        className="bg-slate-900 text-white border-b border-purple-500/20"
      >
        <Modal.Title className="text-purple-300 text-lg font-semibold">
          {location.pathname === "/kundli-matching"
            ? "Recent Matching Kundli"
            : "Recent Kundli"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-slate-900 text-white">
   
          <>
            <div className="relative mb-3">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <svg
                  className="h-5 w-5 text-purple-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                type="text"
                placeholder="Search saved matches..."
                className="w-full pl-12 pr-4 py-3 bg-slate-800/50 border border-purple-500/30 rounded-xl text-purple-100 placeholder-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500/50 transition-all duration-300 hover:border-purple-400/50"
              />
            </div>

            <div className="space-y-4 max_height_clss">
              {filteredTopicList.length === 0 ? (
                <div className="text-center text-purple-300 border border-purple-500/20 bg-slate-800/30 p-6 rounded-lg">
                  💞 <strong>No Saved Kundalis</strong>
                  <p className="mt-2">
                    Create and save your first Kundali to see it here.
                  </p>
                </div>
              ) : (
                filteredTopicList.map((kundali, index) => (
                  <div
                    key={index}
                    className="rounded-lg border bg-slate-800/50 backdrop-blur-sm border-purple-500/20 p-4"
                  >
                    <div className="flex justify-between items-center">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <User size={16} className="text-purple-400" />
                          <h3 className="text-lg font-semibold text-purple-200">
                            {kundali.user_name}
                          </h3>
                          <span className="text-xs px-2 py-1 bg-purple-600/20 text-purple-300 rounded-full">
                            {kundali.user_gender}
                          </span>
                        </div>

                        <div className="space-y-1 text-sm text-purple-300">
                          <div className="flex items-center gap-2">
                            <CalendarIcon size={14} />
                            <span>{formatDOB(kundali.user_dob)}</span>
                            <Clock size={14} className="ml-2" />
                            <span>{kundali.user_dobtime2}</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <MapPin size={14} />
                            <span>
                              {kundali.city_name} {kundali.state_name}{" "}
                              {kundali.country_name}
                            </span>
                          </div>
                          <div className="text-xs text-purple-400">
                            Saved on: {kundali.actual_date}
                          </div>
                        </div>
                      </div>

                      <div className="flex gap-2">
                        {/* <button
                          onClick={() =>
                            handleNavigate(
                              kundali.horoscope_id,
                              kundali.user_gender
                            )
                          }
                          className="flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-sm rounded-full transition-all"
                        >
                          <Eye size={14} />
                          View
                        </button> */}
                        <button
                          onClick={() => handleEditKundali(kundali)}
                          className="flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white text-sm rounded-full transition-all"
                        >
                          <Edit3 size={14} />
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
       
      </Modal.Body>
    </Modal>
  );
}
